import {
  Component,
  Input,
  Directive,
  ElementRef,
  HostListener,
} from "@angular/core";
import { Errors } from "../../../models";

@Component({
  selector: "list-errors",
  templateUrl: "./list-errors.component.html",
  styleUrls: [
    "./list-errors.component.scss",
    "../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class ListErrorsComponent {
  public formattedErrors: Array<string> = [];

  @Input()
  set errors(errorList: Errors) {
    this.formattedErrors = [];

    if (errorList.errors) {
      for (let field in errorList.errors) {
        this.formattedErrors.push(`${field} ${errorList.errors[field]}`);
      }
    }

    if (errorList.error) {
      this.formattedErrors.push(`error: ${errorList.error}`);
    }

    if (errorList.message) {
      this.formattedErrors.push(`message: ${errorList.message}`);
    }
  }

  get errorList() {
    return this.formattedErrors;
  }
}

// directive to remove alert on button click
@Directive({
  selector: "[appRemoveAlert]",
})
export class RemoveAlertDirective {
  public alert_parent: any;
  constructor(private elements: ElementRef) {}

  @HostListener("click", ["$event"])
  onToggle($event: any) {
    $event.preventDefault();
    this.alert_parent = this.elements.nativeElement.parentElement;
    this.alert_parent.remove();
  }
}
